// extracted by mini-css-extract-plugin
export default {"billing-datatable":"BillingDataTable_billing-datatable__kUksg","total-balance-pay":"BillingDataTable_total-balance-pay__b6cPA"};